import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { EVENTS } from "./constants/EmptyStateConstants";

Vue.use(Vuetify);
@Component({
  name: "EmptyState"
})
export default class EmptyState extends Vue {
  @Prop() private headerText!: string;
  @Prop() private paragraphText!: string;
  @Prop() private textButtonCreate!: string;
  @Prop() private showButtonCreate!: boolean;

  onClickButtonCreate() {
    this.$emit(EVENTS.ON_CLICK_BUTTON_CREATE);
  }
}
